<template>
  <ItemListPagination
    class="itemList"
    :columns="$options.columns"
    :currentPageNum="currentPageNum"
    :itemComponent="$options.PwmUserAppsItemListRow"
    :rowsPerPage="rowsPerPage"
    :tableData="visibleTableData"
    :totalCount="totalCount"
    @pageChange="handlePageChange"
  >
    <!-- toolbar is required in order to keep scrollable section from collapsing -->
    <template v-slot:toolbar>
      <div />
    </template>
  </ItemListPagination>
</template>

<script>
import {
  ItemListPagination,
  Types,
} from '@jumpcloud/ui-components';
import PwmUserAppsItemListRow from 'client/PasswordManager/Users/PwmUserAppsItemListRow.vue';

const { Column } = Types;

const columns = [
  Column({
    label: 'OS',
    dataFieldName: 'osId',
    sortable: false,
    width: '1fr',
  }),
  Column({
    label: 'App Version',
    dataFieldName: 'appVersion',
    sortable: false,
    width: '1fr',
  }),
];

export default {
  name: 'PwmUserAppsItemList',

  components: {
    ItemListPagination,
  },

  columns,
  PwmUserAppsItemListRow,

  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      totalCount: this.tableData.length,
      rowsPerPage: 10,
      currentPageNum: 0,
      visibleTableData: this.tableData.slice(0, 10),
    };
  },

  methods: {
    handlePageChange({ currentPageNum, rowsPerPage }) {
      this.currentPageNum = currentPageNum;
      this.rowsPerPage = rowsPerPage;

      const start = currentPageNum * rowsPerPage;
      const end = start + rowsPerPage;
      this.visibleTableData = this.tableData.slice(start, end);
    },
  },
};
</script>

<style scoped>
.itemList {
  height: 30rem;
}
</style>
